import { BasicResult } from "../basic-result";
import { Action } from "./action";
import { ActionListSummary } from "./action-list-summary";

export class ActionResult extends BasicResult{
    public Actions:Action[] = [];
    public Summary: ActionListSummary = new ActionListSummary();
    public PageNumber: number = 1;
    public PageSize: number = 0;
    public TotalCount: number = 0;
    constructor(values: Object = {}){
        super();
        Object.assign(this, values);
        this.Summary = new ActionListSummary((values as ActionResult).Summary || {});
        if(values.hasOwnProperty('Actions')){
            this.Actions = [];
            ((values as ActionResult)['Actions'] as Action[]).forEach(element => {
                this.Actions.push(new Action(element));
            });
        }
    }
}
